import { Developer, BlogPost, Partner, Sponsor, Testimonial } from './types'
// Sample developers data
export const developers = [
  {
    id: '1',
    name: 'John Doe',
    title: 'Senior Laravel Developer',
    bio: 'Experienced Laravel developer with 8+ years of experience building web applications. Specializes in API development and database optimization.',
    skills: [
      { name: 'Laravel' },
      { name: 'PHP' },
      { name: 'MySQL' },
      { name: 'Vue.js' },
      { name: 'API Development' },
    ],
    open_to: ['Full-time', 'Contract', 'Remote'],
    location: 'San Francisco',
    country: 'United States',
    rate: {
      min: 75,
      max: 120,
      currency: 'USD',
    },
    links: {
      website: 'https://johndoe.dev',
      github: 'https://github.com/johndoe',
      twitter: 'https://twitter.com/johndoe',
      linkedin: 'https://linkedin.com/in/johndoe',
    },
    approvalDate: '2023-01-15',
    status: 'available',
    role: 'Backend Developer',
    position: 'Senior',
    avatar: 'https://randomuser.me/api/portraits/men/1.jpg',
  },
  {
    id: '2',
    name: 'Samuel Kimani',
    title: 'Software developer, Writer',
    bio: 'Software developer with 10+ years of professional experience. Also works as a technical writer creating documentation and tutorials.',
    skills: [
      { name: 'Laravel' },
      { name: 'JavaScript' },
      { name: 'React' },
      { name: 'Node.js' },
    ],
    open_to: ['Full-time', 'Contract', 'Remote'],
    location: 'Kampala',
    country: 'Uganda',
    rate: {
      min: 60,
      max: 90,
      currency: 'USD',
    },
    links: {
      website: 'https://samuelkimani.dev',
      github: 'https://github.com/samuelkimani',
      linkedin: 'https://linkedin.com/in/samuelkimani',
    },
    approvalDate: '2023-02-10',
    status: 'available',
    role: 'Full-stack Developer',
    position: 'Senior',
    avatar:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/ryKVEjjJLQHVoWeFx9yS2c/Schermafbeelding_2025-09-22_193432.png',
  },
  {
    id: '3',
    name: 'Markus Schmidt',
    title: 'Software Engineer with a focus on Laravel and Tallstack',
    bio: 'Experienced software engineer specializing in Laravel and the TALL stack (Tailwind, Alpine, Laravel, Livewire).',
    skills: [
      { name: 'Laravel' },
      { name: 'Tailwind CSS' },
      { name: 'Alpine.js' },
      { name: 'Livewire' },
      { name: 'PHP' },
      { name: 'MySQL' },
    ],
    open_to: ['Full-time', 'Contract'],
    location: 'Berlin',
    country: 'Germany',
    rate: {
      min: 80,
      max: 130,
      currency: 'EUR',
    },
    links: {
      website: 'https://markusschmidt.dev',
      github: 'https://github.com/markusschmidt',
      linkedin: 'https://linkedin.com/in/markusschmidt',
    },
    approvalDate: '2023-03-05',
    status: 'available',
    role: 'Full-stack Developer',
    position: 'Senior',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
  },
  {
    id: '4',
    name: 'Jason Parker',
    title: 'Laravel/Vue Developer - 6 Years Experience',
    bio: 'Full-stack developer with 6 years of experience building Laravel and Vue.js applications.',
    skills: [
      { name: 'Laravel' },
      { name: 'Vue.js' },
      { name: 'JavaScript' },
      { name: 'PHP' },
      { name: 'MySQL' },
      { name: 'Tailwind CSS' },
      { name: 'API Development' },
    ],
    open_to: ['Remote', 'Contract'],
    location: 'New York',
    country: 'United States',
    rate: {
      min: 85,
      max: 125,
      currency: 'USD',
    },
    links: {
      website: 'https://jasonparker.dev',
      github: 'https://github.com/jasonparker',
      linkedin: 'https://linkedin.com/in/jasonparker',
    },
    approvalDate: '2023-04-18',
    status: 'available',
    role: 'Full-stack Developer',
    position: 'Senior',
    avatar: 'https://randomuser.me/api/portraits/men/44.jpg',
  },
  {
    id: '5',
    name: 'Miguel Santos',
    title: 'Self Taught Web Developer with over 4 years experience in web',
    bio: 'Self-taught web developer with 4+ years of experience building responsive and user-friendly websites.',
    skills: [
      { name: 'Laravel' },
      { name: 'Vue.js' },
      { name: 'PHP' },
      { name: 'JavaScript' },
      { name: 'CSS' },
      { name: 'HTML' },
    ],
    open_to: ['Full-time', 'Remote'],
    location: 'Manila',
    country: 'Philippines',
    rate: {
      min: 40,
      max: 70,
      currency: 'USD',
    },
    links: {
      website: 'https://miguelsantos.dev',
      github: 'https://github.com/miguelsantos',
      linkedin: 'https://linkedin.com/in/miguelsantos',
    },
    approvalDate: '2023-05-22',
    status: 'available',
    role: 'Front-end Developer',
    position: 'Mid-level',
    avatar: 'https://randomuser.me/api/portraits/men/52.jpg',
  },
  {
    id: '6',
    name: 'Ahmed Hassan',
    title: 'Highly skilled, Software Engineer (PHP/Laravel) with 7 years',
    bio: 'Software engineer with 7 years of experience specializing in PHP and Laravel development.',
    skills: [
      { name: 'Laravel' },
      { name: 'PHP' },
      { name: 'MySQL' },
      { name: 'JavaScript' },
      { name: 'Vue.js' },
      { name: 'Docker' },
    ],
    open_to: ['Full-time', 'Contract', 'Remote'],
    location: 'Cairo',
    country: 'Egypt',
    rate: {
      min: 50,
      max: 90,
      currency: 'USD',
    },
    links: {
      website: 'https://ahmedhassan.dev',
      github: 'https://github.com/ahmedhassan',
      linkedin: 'https://linkedin.com/in/ahmedhassan',
    },
    approvalDate: '2023-06-14',
    status: 'available',
    role: 'Backend Developer',
    position: 'Senior',
    avatar: 'https://randomuser.me/api/portraits/men/62.jpg',
  },
  {
    id: '7',
    name: 'Marco Rossi',
    title: 'Fullstack Laravel Dev (Laravel, Livewire, React, Alpine, Inertia)',
    bio: 'Full-stack developer proficient in Laravel ecosystem including Livewire, React, Alpine.js, and Inertia.js.',
    skills: [
      { name: 'Laravel' },
      { name: 'Livewire' },
      { name: 'React' },
      { name: 'Alpine.js' },
      { name: 'Inertia.js' },
      { name: 'JavaScript' },
    ],
    open_to: ['Contract', 'Remote'],
    location: 'Rome',
    country: 'Italy',
    rate: {
      min: 70,
      max: 110,
      currency: 'EUR',
    },
    links: {
      website: 'https://marcorossi.dev',
      github: 'https://github.com/marcorossi',
      linkedin: 'https://linkedin.com/in/marcorossi',
    },
    approvalDate: '2023-07-08',
    status: 'available',
    role: 'Full-stack Developer',
    position: 'Senior',
    avatar: 'https://randomuser.me/api/portraits/men/72.jpg',
  },
  {
    id: '8',
    name: 'Adrian Popescu',
    title: 'Fullstack Web Developer',
    bio: 'Versatile full-stack web developer with expertise in building complete web applications from front to back.',
    skills: [
      { name: 'Laravel' },
      { name: 'PHP' },
      { name: 'Vue.js' },
      { name: 'React' },
      { name: 'JavaScript' },
      { name: 'MySQL' },
      { name: 'API Development' },
    ],
    open_to: ['Full-time', 'Remote'],
    location: 'Bucharest',
    country: 'Romania',
    rate: {
      min: 55,
      max: 95,
      currency: 'EUR',
    },
    links: {
      website: 'https://adrianpopescu.dev',
      github: 'https://github.com/adrianpopescu',
      linkedin: 'https://linkedin.com/in/adrianpopescu',
    },
    approvalDate: '2023-08-20',
    status: 'available',
    role: 'Full-stack Developer',
    position: 'Senior',
    avatar: 'https://randomuser.me/api/portraits/men/82.jpg',
  },
  {
    id: '9',
    name: 'Jean Dupont',
    title: '15+ years of PHP / 40+ websites / Laravel Developer',
    bio: 'Veteran PHP developer with 15+ years of experience and over 40 websites built. Laravel specialist.',
    skills: [
      { name: 'Laravel' },
      { name: 'PHP' },
      { name: 'MySQL' },
      { name: 'JavaScript' },
      { name: 'CSS' },
      { name: 'HTML' },
      { name: 'API Development' },
    ],
    open_to: ['Contract', 'Consultation', 'Remote'],
    location: 'Paris',
    country: 'France',
    rate: {
      min: 90,
      max: 150,
      currency: 'EUR',
    },
    links: {
      website: 'https://jeandupont.dev',
      github: 'https://github.com/jeandupont',
      linkedin: 'https://linkedin.com/in/jeandupont',
    },
    approvalDate: '2023-09-15',
    status: 'available',
    role: 'Backend Developer',
    position: 'Senior',
    avatar: 'https://randomuser.me/api/portraits/men/92.jpg',
  },
]
// Sample blog posts
export const blogPosts: BlogPost[] = [
  {
    id: '1',
    title: '10 Laravel Performance Tips You Should Know',
    slug: '10-laravel-performance-tips',
    excerpt:
      'Optimize your Laravel application with these 10 performance tips that will help you improve response times and reduce server load.',
    content:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    publishedAt: '2023-06-15',
    author: {
      name: 'John Doe',
      avatar: 'https://randomuser.me/api/portraits/men/11.jpg',
    },
    categories: ['Laravel', 'Performance'],
    readingTime: 8,
    featuredImage:
      'https://via.placeholder.com/800x400?text=Laravel+Performance',
  },
  {
    id: '2',
    title: 'Building a SaaS with Laravel and Vue.js',
    slug: 'building-saas-laravel-vue',
    excerpt:
      'A comprehensive guide to building a Software as a Service application using Laravel for the backend and Vue.js for the frontend.',
    content:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    publishedAt: '2023-05-22',
    author: {
      name: 'Jane Smith',
      avatar: 'https://randomuser.me/api/portraits/women/11.jpg',
    },
    categories: ['Laravel', 'Vue.js', 'SaaS'],
    readingTime: 15,
    featuredImage: 'https://via.placeholder.com/800x400?text=Laravel+Vue+SaaS',
  },
  {
    id: '3',
    title: 'Laravel Horizon: Monitoring Your Redis Queues',
    slug: 'laravel-horizon-monitoring-redis-queues',
    excerpt:
      'Learn how to use Laravel Horizon to monitor and manage your Redis queues for better application performance and insight.',
    content:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    publishedAt: '2023-04-10',
    author: {
      name: 'Michael Brown',
      avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
    },
    categories: ['Laravel', 'Redis', 'Queues'],
    readingTime: 6,
    featuredImage: 'https://via.placeholder.com/800x400?text=Laravel+Horizon',
  },
]
// Sample partners
export const partners: Partner[] = [
  {
    id: '1',
    name: 'Acme Tech',
    logo: 'https://via.placeholder.com/200x100?text=Acme+Tech',
    description:
      'Leading technology provider specializing in cloud solutions and enterprise software.',
    website: 'https://acmetech.example.com',
    featured: true,
  },
  {
    id: '2',
    name: 'DevOps Pro',
    logo: 'https://via.placeholder.com/200x100?text=DevOps+Pro',
    description:
      'DevOps consulting and implementation services for modern web applications.',
    website: 'https://devopspro.example.com',
    featured: true,
  },
  {
    id: '3',
    name: 'Cloud Servers Inc',
    logo: 'https://via.placeholder.com/200x100?text=Cloud+Servers',
    description:
      'Reliable cloud hosting optimized for Laravel applications with 24/7 support.',
    website: 'https://cloudservers.example.com',
    featured: false,
  },
  {
    id: '4',
    name: 'Web Security Solutions',
    logo: 'https://via.placeholder.com/200x100?text=Web+Security',
    description:
      'Comprehensive web security services and tools for protecting your applications.',
    website: 'https://websecurity.example.com',
    featured: false,
  },
]
// Sample sponsors
export const sponsors: Sponsor[] = [
  {
    id: '1',
    name: 'Laravel Inc',
    logo: 'https://via.placeholder.com/200x100?text=Laravel+Inc',
    tier: 'gold',
    website: 'https://laravel.com',
    description:
      'The official Laravel company, providing tools and services for Laravel developers.',
  },
  {
    id: '2',
    name: 'Digital Ocean',
    logo: 'https://via.placeholder.com/200x100?text=Digital+Ocean',
    tier: 'gold',
    website: 'https://digitalocean.com',
    description:
      'Cloud infrastructure provider with simple pricing and powerful features.',
  },
  {
    id: '3',
    name: 'Forge',
    logo: 'https://via.placeholder.com/200x100?text=Forge',
    tier: 'silver',
    website: 'https://forge.laravel.com',
    description:
      'Server management and deployment service for Laravel applications.',
  },
  {
    id: '4',
    name: 'Envoyer',
    logo: 'https://via.placeholder.com/200x100?text=Envoyer',
    tier: 'silver',
    website: 'https://envoyer.io',
    description: 'Zero downtime deployment service for PHP applications.',
  },
  {
    id: '5',
    name: 'Vapor',
    logo: 'https://via.placeholder.com/200x100?text=Vapor',
    tier: 'bronze',
    website: 'https://vapor.laravel.com',
    description: 'Serverless deployment platform for Laravel applications.',
  },
]
// Sample testimonials
export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Sarah Johnson',
    title: 'CTO',
    company: 'TechStart Inc.',
    avatar: 'https://randomuser.me/api/portraits/women/32.jpg',
    content:
      'CertifiedDevelopers has transformed our hiring process. We found an amazing certified developer who integrated perfectly with our team and delivered exceptional work.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Michael Chen',
    title: 'Product Manager',
    company: 'CloudSoft',
    avatar: 'https://randomuser.me/api/portraits/men/42.jpg',
    content:
      'The certification process is rigorous and meaningful. As a developer, it has helped me stand out in a competitive market and connect with quality clients.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Elena Rodriguez',
    title: 'Founder',
    company: 'DevMatch',
    avatar: 'https://randomuser.me/api/portraits/women/63.jpg',
    content:
      "The quality of developers on this platform is outstanding. We've hired three certified developers so far, and each has exceeded our expectations.",
    rating: 4,
  },
  {
    id: 4,
    name: 'David Kim',
    title: 'Senior Laravel Developer',
    company: 'Freelancer',
    avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
    content:
      "Getting certified boosted my freelance career significantly. I've received more job offers and can charge higher rates thanks to the credibility it provides.",
    rating: 5,
  },
  {
    id: 5,
    name: 'Olivia Taylor',
    title: 'HR Director',
    company: 'WebTech Solutions',
    avatar: 'https://randomuser.me/api/portraits/women/17.jpg',
    content:
      "As a hiring manager, I appreciate how the certification verifies skills and saves us time in the vetting process. It's become our go-to source for certified talent.",
    rating: 5,
  },
  {
    id: 6,
    name: 'James Wilson',
    title: 'CEO',
    company: 'AppDev Studios',
    avatar: 'https://randomuser.me/api/portraits/men/65.jpg',
    content:
      'The hands-on services helped us optimize our Laravel application performance by 40%. The experts were knowledgeable and delivered excellent results.',
    rating: 4,
  },
]
